module.exports = __webpack_public_path__ + "img/floodfighting-20160720-02-1024x768.71fc762b.jpg";